module.exports = __webpack_public_path__ + "img/my-media.54105030.svg";